import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  let token = localStorage.getItem("operator_token");
  if (token) {
    try {
      const exp = JSON.parse(atob(token.split(".")[1])).exp;
      if (exp && exp * 1000 < Date.now()) token = null;
    } catch { token = null; }
    if (!token) localStorage.removeItem("operator_token");
  }
  const op = localStorage.getItem("active_operator");
  if (token) config.headers["X-Operator-Token"] = token;
  else if (op) config.headers["X-Operator-Name"] = op;
  return config;
});

export function formatApiError(e, fallback = "Si è verificato un errore") {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || "").filter(Boolean).join(" ");
  return fallback;
}
